function initImageGalleryCarousel() {
    let $imageGallerySlider = $('.image-gallery__slider');
    if($imageGallerySlider.length < 1) return;

    $imageGallerySlider.slick({
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        mobileFirst: false,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    arrows: false,
                    centerPadding: '30%',
                    centerMode: true,
                    slidesToShow: 1
                }
            }
        ]
    });

    $imageGallerySlider.slick('setPosition');
}

$(function () {
    initImageGalleryCarousel();
});

$(window).resize(function () {
    $('.image-gallery__slider').slick('setPosition');
});
